import React, { useState } from 'react';
import { Input, Button, message, Row, Col, Spin } from 'antd';
import { EnvironmentOutlined } from '@ant-design/icons';
import api from '../services/api';

const AddressInput = ({ 
  value, 
  onChange, 
  onCoordinatesChange,
  placeholder = "Digite o endereço completo",
  disabled = false 
}) => {
  const [loading, setLoading] = useState(false);

  const handleSearchCoordinates = async () => {
    if (!value?.trim()) {
      message.warning('Digite um endereço para buscar');
      return;
    }

    setLoading(true);
    try {
      const response = await api.get('/geocoding/coordinates', {
        params: { address: value }
      });

      const { latitude, longitude, address_components } = response.data;
      
      // Callback com as coordenadas
      if (onCoordinatesChange) {
        onCoordinatesChange({
          latitude,
          longitude,
          city: address_components.city,
          state: address_components.state,
          neighborhood: address_components.neighborhood
        });
      }

      message.success('Coordenadas encontradas!');
    } catch (error) {
      if (error.response?.status === 404) {
        message.error('Endereço não encontrado. Tente ser mais específico.');
      } else {
        message.error('Erro ao buscar coordenadas');
      }
    }
    setLoading(false);
  };

  return (
    <Row gutter={8}>
      <Col flex="auto">
        <Input
          value={value}
          onChange={(e) => onChange?.(e.target.value)}
          placeholder={placeholder}
          disabled={disabled}
        />
      </Col>
      <Col>
        <Button
          icon={<EnvironmentOutlined />}
          onClick={handleSearchCoordinates}
          loading={loading}
          disabled={disabled || !value?.trim()}
          title="Buscar coordenadas"
        >
          {loading ? <Spin size="small" /> : 'Buscar'}
        </Button>
      </Col>
    </Row>
  );
};

export default AddressInput;